import axios from "axios";
import { useState } from "react";

const usePOST = () => {
    const [data, setData] = useState(null);
    const [isErr, setIsErr] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const sendRequest = async ({ link, body, headers }) => {
        setIsLoading(true)
        try {
            const res = await axios.post(link, body, { headers: headers });
            const resData = res?.data?.data?.data ?? res?.data?.data ?? res?.data;
            setData(resData);
            setIsErr(null);
        } catch (err) {
            setIsErr(err?.message || "عذرا حدث خطأ برجاء المحاولة مره أخرى");
        } finally {
            setIsLoading(false);
        }
    };

    return { sendRequest, data, isErr, isLoading, setIsErr, setIsLoading };

}
export default usePOST;